import { createSlice } from "@reduxjs/toolkit";

const leftNavSlice = createSlice({
  name: "letSideNav",
  initialState: {
    selectedSection: "",
    activeAccordionKey: "",
    primaryContact: {},
  },
  reducers: {
    updateLeftNav: (state, { payload }) => ({ ...state, ...payload }),
    updateVendorPrimaryContact: (state, { payload }) => {
      return {
        ...state,
        primaryContact: {
          ...state.primaryContact,
          ...payload,
        },
      };
    },
  },
});

export const {
  updateLeftNav,
  updateVendorPrimaryContact,
} = leftNavSlice.actions;
export default leftNavSlice.reducer;
